// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1X5k8","content":"Consent_content__3aKPk","footer":"Consent_footer__1eRRv"};